/**
 * Which GST name a vendor goes by — mirrors vendorhub-backend/src/utils/vendorName.ts.
 * The vendor's name (company_name) is its GST trade name; the legal name is kept beside it
 * (gst_legal_name) and is the name only when there is no usable trade name.
 */
const PLACEHOLDERS = new Set(['NA', 'N A', 'NIL', 'NULL', 'NONE', 'NOT APPLICABLE', 'NOTAPPLICABLE', 'UNDEFINED', '0']);

export const cleanName = (value) => {
  if (value === undefined || value === null) return '';
  return String(value).replace(/\s+/g, ' ').trim();
};

export const isUsableName = (value) => {
  const s = cleanName(value);
  if (!s) return false;
  const letters = s.toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  return !!letters && !PLACEHOLDERS.has(letters);
};

export const preferTradeName = (tradeName, legalName) =>
  isUsableName(tradeName) ? cleanName(tradeName) : isUsableName(legalName) ? cleanName(legalName) : '';

/** The legal name, only when it says something the vendor name does not. */
export const distinctLegalName = (vendorName, legalName) => {
  const legal = cleanName(legalName);
  if (!isUsableName(legal)) return '';
  return legal.toUpperCase() === cleanName(vendorName).toUpperCase() ? '' : legal;
};
